import React from 'react';
import PropTypes from 'prop-types';
import './AlertMessage.css';
import { ReactComponent as WarningIcon } from './icons/warning.svg';
import { ReactComponent as AlertIcon } from './icons/alert.svg';
import { ReactComponent as DoneIcon } from './icons/done.svg';

const AlertMessage = ({ children, type, slim = false, iconComponent, iconClassName }) => {

  const Icon = {
    'warning': WarningIcon,
    'info': AlertIcon,
    'status': DoneIcon,
    'transparent': WarningIcon
  }[type];
  const DisplayIcon = iconComponent || Icon;

  const slimClass = slim ? 'alert-message-slim' : '';

  return (
    <div className={`alert-message ${type} ${slimClass}`}>
      <DisplayIcon className={iconClassName} aria-hidden="true" />
      <p aria-live="polite">{children}</p>
    </div>
  );
};

AlertMessage.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['warning', 'info', 'status', 'transparent']),
  slim: PropTypes.bool,
  iconComponent: PropTypes.elementType,
  iconClassName: PropTypes.string
};

export default AlertMessage;
